import logo from "./logo.svg";
import "./App.css";
import Section1 from "./components/section 1/Section1";
import Section2 from "./components/section 2/Section2";
import Section3 from "./components/section 3/Section3";
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material/styles";
import { Toolbar } from "@mui/material";
import Section4 from "./components/section 4/Section4";
import Section5 from "./components/section 5/Section5";

let theme = createTheme();
theme = responsiveFontSizes(theme);

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Toolbar />
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
      </ThemeProvider>
    </>
  );
}

export default App;
